import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const redeemPromoCode = payload =>
  call(websocketFetch, 'redeem_promo_code', payload);
